import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

function RowShell({ active, onHover, innerRef, children }) {
  return (
    <li
      ref={innerRef}
      className={clsx(
        'flex items-center gap-2.5 rounded-(--gs-row-radius) px-2.5 py-(--gs-row-padding-y) transition-colors duration-(--gs-transition)',
        active && 'bg-llama-grey-9',
      )}
      onMouseEnter={onHover}
    >
      {children}
    </li>
  );
}

RowShell.propTypes = {
  active: PropTypes.bool.isRequired,
  onHover: PropTypes.func.isRequired,
  innerRef: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export default RowShell;
